import React from 'react';

import {
  uiRoutes,
} from '@consumer-frontend/nc-api';
import { Icon } from '@consumer-frontend/shared-ui';

import { NcLegacyLink } from '../NcLegacyLink';

export type NcAddDebitCardT = React.FC;

export const NcAddDebitCard: NcAddDebitCardT = () => {
  return (
    <p className="nc-payment-method-add-debit">
      <NcLegacyLink href={uiRoutes.legacyAH.managePaymentMethods}>
        <Icon className="add-debit-icon" iconName="plus-circle" />
        Add Debit Card
      </NcLegacyLink>
    </p>
  );
};
